export const tableColumnConfigDefaults = {
  sortingFn: 'auto',
  enableSorting: true,
  sortingState: 'asc',
  sortDescFirst: true,
};
export const disabledSortingConfig = {
  sortingFn: undefined,
  enableSorting: false,
};

// default: 70% of all columns have sorting enabled to show sorting icon only on hover
export const SORTING_ON_HOVER_COLUMN_COUNT_RATE = 70;
